import React, { Component } from "react";

export default class ErrorBoundary extends Component {

    componentDidCatch(error, errorInfo) {
        console.error(error);
        console.error(errorInfo);
    }

    render() {
        return this.props.children;
    }
}